import React from "react";

function WhatisCDE() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>What is a Crypto Derivatives Exchange?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  A crypto derivatives exchange is a trading platform where
                  users can trade financial contracts based on the value of
                  cryptocurrencies, without actually owning the underlying
                  assets. These contracts, called derivatives, include futures,
                  options, and perpetual swaps, allowing traders to speculate on
                  the price movements of cryptocurrencies like Bitcoin or
                  Ethereum.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WhatisCDE;
